import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { FiArrowLeft } from 'react-icons/fi';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goBack = () => {
    window.history.back();
  };

  return (
    <div className="min-h-screen bg-brand-black text-white/80 font-inter pt-32 pb-20 px-6">
      <div className="max-w-4xl mx-auto">
        <button onClick={goBack} className="flex items-center gap-2 text-brand-gold hover:text-brand-orange transition-colors mb-8 text-sm uppercase tracking-widest font-cinzel">
          <FiArrowLeft /> Back
        </button>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <h1 className="text-3xl md:text-5xl font-cinzel text-brand-gold mb-8">Privacy Policy</h1>
          <div className="space-y-6 text-sm md:text-base leading-relaxed text-white/60">
            <p><strong>Effective Date:</strong> {new Date().toLocaleDateString()}</p>
            <h2 className="text-xl text-white mt-8 mb-4">1. Introduction</h2>
            <p>Welcome to Magic Moon Studios. We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website.</p>
            
            <h2 className="text-xl text-white mt-8 mb-4">2. The Data We Collect About You</h2>
            <p>Personal data, or personal information, means any information about an individual from which that person can be identified. We may collect, use, store and transfer different kinds of personal data about you including:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Identity Data</strong> includes first name, last name, username or similar identifier.</li>
              <li><strong>Contact Data</strong> includes email address and telephone numbers.</li>
              <li><strong>Technical Data</strong> includes internet protocol (IP) address, your login data, browser type and version, time zone setting and location.</li>
            </ul>

            <h2 className="text-xl text-white mt-8 mb-4">3. How We Use Your Personal Data</h2>
            <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
              <li>Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</li>
              <li>Where we need to comply with a legal obligation.</li>
            </ul>

            <h2 className="text-xl text-white mt-8 mb-4">4. Data Security</h2>
            <p>We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorised way, altered or disclosed.</p>

            <h2 className="text-xl text-white mt-8 mb-4">5. Contact Us</h2>
            <p>If you have any questions about this privacy policy or our privacy practices, please contact us at privacy@magicmoonstudios.com.</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
